import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { OrderDetails } from '../shared/model/order-details.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CartPaymentService {

    private apiUrl = environment.apiUrl + '/hosted/v1/cardpayment';
    
    constructor(private httpClient: HttpClient) { }

    /*public purchase(hostedOrderPaymentToken: string,
        cardPaymentToken: string) : Observable<boolean> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'POST, PUT, GET, OPTIONS'
            })
        };

        httpOptions.headers = httpOptions.headers.set('Access-Control-Allow-Origin', '*');
        httpOptions.headers = httpOptions.headers.set('Access-Control-Allow-Methods', 'POST, PUT, GET, OPTIONS');

        var payload = {
            'orderHostedToken': hostedOrderPaymentToken,
            'cardPaymentToken': cardPaymentToken
        };

        return this.httpClient.post<boolean>(this.apiUrl + "/purchase", payload);
    }*/

    public purchase(hostedOrderPaymentToken: string,
        cardPaymentToken: string) : Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'POST, PUT, GET, OPTIONS'
            })
        };

        httpOptions.headers = httpOptions.headers.set('Access-Control-Allow-Origin', '*');
        httpOptions.headers = httpOptions.headers.set('Access-Control-Allow-Methods', 'POST, PUT, GET, OPTIONS');

        var payload = {
            'orderHostedToken': hostedOrderPaymentToken,
            'cardPaymentToken': cardPaymentToken
        };

        return this.httpClient.post<any>(this.apiUrl + "/purchase", payload);
    }

}